import { render, staticRenderFns } from "./DescomplicaShortLogo.vue?vue&type=template&id=73632034&scoped=true&"
import script from "./DescomplicaShortLogo.vue?vue&type=script&lang=ts&"
export * from "./DescomplicaShortLogo.vue?vue&type=script&lang=ts&"
import style0 from "./DescomplicaShortLogo.vue?vue&type=style&index=0&id=73632034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73632034",
  null
  
)

export default component.exports